<template>
  <div>
    <button @click="probarIris">Probar Iris</button>
    <p v-if="respuesta">{{ respuesta }}</p>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      respuesta: null,
    }
  },
  methods: {
    async probarIris() {
      try {
        const data = await API.testIris()
        this.respuesta = JSON.stringify(data)
      } catch (error) {
        console.error(error)
        this.respuesta = 'Error al llamar API'
      }
    }
  }
}
</script>
